(function () {
  'use strict';

  angular
    .module('component.addtocart', [])

    .component('buttonAddToCart', {
      require: {
        productCtrl: '?^^productDetail',
        comparatorCtrl: '?^^comparator'
      },
      bindings: {
        isProductButton: '<?',
        isCartButton: '<?',
        action: '&?',
        btnClass: '@',
        idLine: '<?',
        commentLine: '@?',
        id: '<idProduct',
        productQuantity: '<?',
        isPrimary: '<',
        addToCartActive: '<?',
        allowAddToCart: '<',
        price: '<productPrice',
        designation: '@productDesignation',
        img: '@productImg',
        url: '@productUrl',
        titleAdd: '@?',
        titleAlert: '@?',
        btnTooltip: '@',
        modalCtrl: '<',
        toastAdd: '<?',
        device: '<',
        idReplacementProduct: '<?',
        modalReplacementTitle: '@?',
        modalReplacementText: '@?'
      },
      templateUrl: 'component.addtocart.tpl',
      /* @ngInject */
      controller: ["$scope", "AppService", "ModalService", "RoutesService", "toastr", function ($scope, AppService, ModalService, RoutesService, toastr) {
        var ctrl = this,
          showTTCPrice = true;

        ctrl.$onInit = function () {
          if (ctrl.addToCartActive === undefined) {
            ctrl.addToCartActive = true;
          }

          if (ctrl.isProductButton) {
            ctrl.defaultTooltip = ctrl.btnTooltip;
            ctrl.tooltip = ctrl.defaultTooltip;
            $scope.$on('updateTooltip', function (event, tooltip) {
              ctrl.tooltip = tooltip || ctrl.defaultTooltip;
            });

            $scope.$on('updateComment', function (event, hash) {
              ctrl.commentLine = hash;
            });
          }

          ctrl.ready = true;

          AppService.getParams()
            .then(function (params) {
              showTTCPrice = params.Visitor.CardType.ShowTTCPrice;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.addToCart = function () {
          if (ctrl.idReplacementProduct) {
            ModalService.show(
              '/Template/Modal/ModalQuickView',
              {
                url: 'choose-p-' + ctrl.idReplacementProduct,
                selectReplacement: true,
                windowClass: 'modal-quick-view'
              },
              'xl',
              'modalQuickViewCtrl',
              null,
              ctrl.device,
              {
                modalTitle: ctrl.modalReplacementTitle,
                modalText: ctrl.modalReplacementText
              }
            );
          } else {
            if (typeof ctrl.action != 'undefined') {
              addToCart(ctrl.action({ qty: ctrl.productCtrl.quantity, inc: ctrl.productCtrl.quantity }), ctrl.productCtrl.quantity);
            } else {
              var qty = ctrl.comparatorCtrl ? ctrl.comparatorCtrl.quantities[ctrl.id] : ctrl.productQuantity;
              addToCart(getProductsToAdd(qty), qty);
            }
          }
        };

        // Functions

        function getProductsToAdd(qty) {
          return [{
            idLine: ctrl.idLine,
            Comment: ctrl.commentLine || '',
            idProduct: ctrl.id,
            Price: AppService.getProductPrice(ctrl.price, qty),
            costTTC: 0,
            costHT: 0,
            showTTCPrice: showTTCPrice,
            quantity: qty,
            designation: ctrl.designation,
            img: ctrl.img,
            URL: ctrl.url
          }];
        }

        function addToCart(products) {
          if (!ctrl.toastAdd) {
            // ModalService.close();
            ModalService.show(
              '/Template/Modal/ModalAddToCart',
              products,
              null,
              'modalAddToCartCtrl',
              null,
              null,
              {
                cartLink: '/' + RoutesService.getUrlByName('Cart')
              }
            );

            AppService.addToCart(products)
              .then(function (response) {
                if (response.status === 'OK') {
                  AppService.updateParams(response.results);
                } else {
                  AppService.getTranslate()
                    .then(function (translate) {
                      toastr.warning(translate.errors.TryLater,
                        translate.errors.ErrorHasOccurred,
                        {
                          allowHtml: true,
                          extraData: {
                            template: 'toast_message.tpl'
                          }
                        });
                    });
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          } else {
            var mess = ctrl.titleModifyOk;
            toastr.success(ctrl.designation, mess, {
              allowHtml: true,
              extraData: {
                template: 'toast_addtocart.tpl',
                data: {
                  img: products[0].img
                }
              }
            });
          }
        }
      }]
    });

})();
